/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_CloudInputs */

const en_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Storage`)
};

const fr_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage cloud`)
};

const de_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Speicher`)
};

const it_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione cloud`)
};

const ru_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облачное хранилище`)
};

const es_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento en la nube`)
};

const zh_cn2_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云存储`)
};

const ja_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウドストレージ`)
};

const hi_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घन संग्रहण`)
};

const pt_pt2_media_import_source_cloud = /** @type {(inputs: Media_Import_Source_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento em nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud Storage" |
*
* @param {Media_Import_Source_CloudInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_cloud = /** @type {((inputs?: Media_Import_Source_CloudInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_CloudInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_cloud(inputs)
	if (locale === "de") return de_media_import_source_cloud(inputs)
	if (locale === "it") return it_media_import_source_cloud(inputs)
	if (locale === "ru") return ru_media_import_source_cloud(inputs)
	if (locale === "es") return es_media_import_source_cloud(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_cloud(inputs)
	if (locale === "ja") return ja_media_import_source_cloud(inputs)
	if (locale === "hi") return hi_media_import_source_cloud(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_cloud(inputs)
	return en_media_import_source_cloud(inputs)
});